import * as React from 'react';
import {Checkbox} from 'semantic-ui-react';

interface RadioButtonElement {
    label: string;
    callBack: () => void;
}

interface RadioChooseProps {
    style?: string;
    selectedDefault: number;
    elements: Array<RadioButtonElement>;
}

interface RadioChooseState {
    checkedRadioIndex: number;
}

class RadioChoose extends React.Component<RadioChooseProps, RadioChooseState> {
    constructor(props) {
        super(props);

        const {selectedDefault} = props;
        this.state = {
            checkedRadioIndex: selectedDefault
        };
    }

    onRadioChange(index, callBack) {
        this.setState(
            {
                checkedRadioIndex: index
            },
            () => {
                callBack && callBack();
            }
        );
    }

    renderButtons() {
        const {elements} = this.props;

        return elements.map((button, index) => {
            const {label, callBack} = button;
            return (
                <Checkbox
                    key={`radio-button-${index}`}
                    label={label}
                    radio
                    className="rdo-group"
                    name="radioGroup"
                    checked={index === this.state.checkedRadioIndex}
                    onChange={() => this.onRadioChange(index, callBack)}
                />
            );
        });
    }

    render() {
        return <div className="buttons-container">{this.renderButtons()}</div>;
    }
}

export default RadioChoose;
